var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 128,
    viewBox: "0 0 113 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 97,
    height: 122,
    rx: 12,
    fill: "#B4B4B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 94,
    height: 122,
    rx: 12,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 86,
    height: 43,
    rx: 12,
    fill: "#004F59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 78.06V99H15.07V78.06H19.27ZM46.2496 78.06V99H42.0496V85.38L36.4396 99H33.2596L27.6196 85.38V99H23.4196V78.06H28.1896L34.8496 93.63L41.5096 78.06H46.2496ZM64.982 84.36C64.502 83.48 63.842 82.81 63.002 82.35C62.162 81.89 61.182 81.66 60.062 81.66C58.822 81.66 57.722 81.94 56.762 82.5C55.802 83.06 55.052 83.86 54.512 84.9C53.972 85.94 53.702 87.14 53.702 88.5C53.702 89.9 53.972 91.12 54.512 92.16C55.072 93.2 55.842 94 56.822 94.56C57.802 95.12 58.942 95.4 60.242 95.4C61.842 95.4 63.152 94.98 64.172 94.14C65.192 93.28 65.862 92.09 66.182 90.57H58.982V87.36H70.322V91.02C70.042 92.48 69.442 93.83 68.522 95.07C67.602 96.31 66.412 97.31 64.952 98.07C63.512 98.81 61.892 99.18 60.092 99.18C58.072 99.18 56.242 98.73 54.602 97.83C52.982 96.91 51.702 95.64 50.762 94.02C49.842 92.4 49.382 90.56 49.382 88.5C49.382 86.44 49.842 84.6 50.762 82.98C51.702 81.34 52.982 80.07 54.602 79.17C56.242 78.25 58.062 77.79 60.062 77.79C62.422 77.79 64.472 78.37 66.212 79.53C67.952 80.67 69.152 82.28 69.812 84.36H64.982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.fa13f14bb6e817fdbb4aaff90eed9d40.svg";
export { ForwardRef as ReactComponent };